import { z } from "zod";
import { apiBuilder, prefixApi } from "@zodios/core";
import { datasetFilterSchema, dspDatasetsPaginationSchema } from "./common";

const dspProductMetricFields = {
  total_detail_page_view: z.number().nullable().optional(),
  total_detail_page_view_prev: z.number().nullable().optional(),
  total_detail_page_view_delta: z.number().nullable().optional(),
  total_detail_page_view_percent: z.number().nullable().optional(),

  new_to_brand_detail_page_view: z.number().nullable().optional(),
  new_to_brand_detail_page_view_prev: z.number().nullable().optional(),
  new_to_brand_detail_page_view_delta: z.number().nullable().optional(),
  new_to_brand_detail_page_view_percent: z.number().nullable().optional(),

  total_add_to_cart: z.number().nullable().optional(),
  total_add_to_cart_prev: z.number().nullable().optional(),
  total_add_to_cart_delta: z.number().nullable().optional(),
  total_add_to_cart_percent: z.number().nullable().optional(),

  total_purchases: z.number().nullable().optional(),
  total_purchases_prev: z.number().nullable().optional(),
  total_purchases_delta: z.number().nullable().optional(),
  total_purchases_percent: z.number().nullable().optional(),

  total_new_to_brand_dpvs: z.number().nullable().optional(),
  total_new_to_brand_dpvs_prev: z.number().nullable().optional(),
  total_new_to_brand_dpvs_delta: z.number().nullable().optional(),
  total_new_to_brand_dpvs_percent: z.number().nullable().optional(),

  total_units_sold: z.number().nullable().optional(),
  total_units_sold_prev: z.number().nullable().optional(),
  total_units_sold_delta: z.number().nullable().optional(),
  total_units_sold_percent: z.number().nullable().optional(),
};

const dspProductRowSchema = z.object({
  asin: z.string().optional(),
  conversion_type: z.string().optional(),
  product_name: z.string().optional(),
  report_granularity: z.string().optional(),
  featured_asin: z.string().optional(),
  start_date: z.string().optional(),
  ...dspProductMetricFields,
});

export type DSPProductRow = z.infer<typeof dspProductRowSchema>;

const dspProductQueryRequestSchema = z.object({
  model: z.literal("dspproduct"),
  dimensions: z.union([z.string(), z.array(z.string())]),
  filters: z.array(datasetFilterSchema).optional().default([]),
  sort: z.string().optional(),
  page: z.number().optional(),
  limit: z.number().optional(),
  include_count: z.boolean().optional(),
});

const dspProductQueryResponseSchema = z.object({
  data: z.array(dspProductRowSchema),
  pagination: dspDatasetsPaginationSchema,
});

export const dspProductDatasetsApiDefinitions = prefixApi(
  "/api",
  apiBuilder({
    method: "post",
    path: "/datasets/query/?product",
    alias: "dspProductDatasetsQuery",
    description: "Query product datasets by dimensions + filters",
    parameters: [
      {
        name: "body",
        type: "Body",
        schema: dspProductQueryRequestSchema,
      },
    ],
    response: dspProductQueryResponseSchema,
  }).build(),
);
